// extracted by mini-css-extract-plugin
var _1 = "otp-w9WUI";
export { _1 as "otp" }
